import React, { useState } from "react";
import { Button, Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";

function RTableActionsModal({
  isModalOpen,
  handleOk,
  handleCancel,
  action,
  actionMessage,
}) {
  const message = {
    handleEmailInterest: " Interest email(s) will be sent.",
    handleInterviewReminder: " Interview reminder email(s) will be sent.",
    DuplicateJD: "JD will be duplicated",
    DeleteJD: "JD will be deleted",
    Delete: "Resume(s) will be deleted from this JD",
  };

  const buttonMessage = {
    handleEmailInterest: "Send",
    handleInterviewReminder: "Send",
    DeleteJD: "Delete JD",
    DuplicateJD: "Duplicate JD",
    Delete: "Delete",
  };

  return (
    <Modal
      title={
        <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <ExclamationCircleFilled style={{ color: "#faad14" }} />
          {actionMessage}
        </span>
      }
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
      closable
      okText={buttonMessage[action]}
      okButtonProps={
        action === "Delete" || action === "DeleteJD" ? { danger: true } : {}
      }
    >
      <p>{message[action]}</p>
    </Modal>
  );
}

export default RTableActionsModal;
